"use client";

import { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useS3Upload } from "next-s3-upload";
import { IoCloudUploadOutline } from "react-icons/io5";
import "./style.css";
import { useRouter } from "next/navigation";

const extractS3Key = (url: string) => {
  const urlObject = new URL(url);
  // Remove the leading slash to get the key directly
  return urlObject.pathname.substring(1);
};

export default function WillAITakeYourJob() {
  const [uploading, setUploading] = useState(false);
  const { uploadToS3, files } = useS3Upload();
  const router = useRouter();

  const onDrop = useCallback(async (acceptedFiles: File[]) => {
    const file = acceptedFiles[0]; // Only take the first file
    if (file) {
      setUploading(true); // Set uploading to true when upload starts
      const { key } = await uploadToS3(file);

      // remove dot from the keyName and change to underscore
      const keyName = key.replace(/\./g, "_");
      // console.log("Bucket Name: ", key);

      if (keyName) {
        return router.push(`/will-ai-take-my-job/${keyName}`);
      }

      setUploading(false); // Set uploading to false when upload finishes
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false, // Only allow one file to be dropped at a time
    accept: {
      "application/pdf": [".pdf"],
    },
  });

  return (
    <>
      <div
        className="card bg-base-200 mx-auto mt-8 flex h-full min-h-[300px] w-full justify-start rounded-lg border-2 border-dashed align-middle"
        {...getRootProps()}
      >
        <div className="flex h-full w-full flex-col items-center justify-center align-middle">
          <input {...getInputProps()} />
          <>
            <button className="btn btn-primary flex max-w-[300px] flex-row text-white">
              <IoCloudUploadOutline className="text-4xl " />
              Upload your Resume
            </button>
            <h3 className="mt-5 text-center text-xl">Your resume is automatically deleted after 24h</h3>
            {uploading && (
              <>
                <progress
                  className="progress mt-10 w-56"
                  value={(files?.[0]?.progress || 0) * 100}
                  max="100"
                ></progress>
                <span className="loading loading-infinity loading-lg"></span>
                <h3 className="text-xl">Uploading...</h3>
              </>
            )}
          </>
          {uploading && <div className="upload-overlay" />}
        </div>
      </div>
    </>
  );
}
